import Big from 'big.js';

/**
 * 加法运算，对多个数字进行相加。
 * @param args - 要相加的数字。
 * @returns 数字的和。
 */
export const add = function () {
  try {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return args.reduce((x, y) => {
      return Number(Big(x).plus(y).valueOf());
    });
  } catch (error) {
    console.error(error);
    return NaN;
  }
};

/**
 * 减法运算，对多个数字进行相减。
 * @param args - 要相减的数字。
 * @returns 数字的差。
 */
export const sub = function () {
  try {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return args.reduce((x, y) => {
      return Number(Big(x).minus(y).valueOf());
    });
  } catch (error) {
    console.error(error);
    return NaN;
  }
};

/**
 * 乘法运算，对多个数字进行相乘。
 * @param args - 要相乘的数字。
 * @returns 数字的积。
 */
export const mul = function () {
  try {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return args.reduce((x, y) => {
      return Number(Big(x).times(y).valueOf());
    });
  } catch (error) {
    console.error(error);
    return NaN;
  }
};

/**
 * 除法运算，对多个数字进行相除。
 * @param args - 要相除的数字。
 * @returns 数字的商。
 */
export const div = function () {
  try {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return args.reduce((x, y) => {
      return Number(Big(x).div(y).valueOf());
    });
  } catch (error) {
    console.error(error);
    return NaN;
  }
};

/**
 * 对一个数字进行指数运算。
 * @param x - 底数。
 * @param n - 指数。
 * @returns x 的 n 次幂的结果。
 */
export const pow = (x, n) => {
  try {
    return Number(Big(x).pow(n).valueOf());
  } catch (error) {
    console.error(error);
    return NaN;
  }
};

/**
 * 将一个数字四舍五入到指定的精度。
 * @param value - 要四舍五入的数字。
 * @param option.precision - 要保留的小数位数。默认为 2。
 * @param option.mode - 四舍五入模式。可以是 'ceil'、'floor' 或 'round'。默认为 'round'。
 * @returns 四舍五入后的数字。
 */
export const toFixed = (value, option) => {
  var _option$precision;
  const p = 10 ** ((_option$precision = option === null || option === void 0 ? void 0 : option.precision) !== null && _option$precision !== void 0 ? _option$precision : 2);
  let num = mul(value, p);
  switch (option === null || option === void 0 ? void 0 : option.mode) {
    case 'floor':
      num = Math.floor(num);
      break;
    case 'ceil':
      num = Math.ceil(num);
      break;
    default:
      num = Math.round(num);
      break;
  }
  return div(num, p);
};